import React from 'react';
import { TBannerProps } from '../../types/productSeriesDetailFeature.types';
import { getThumbnailProps } from '../../../../utils/youtubeUtils';
import MediaCarousel from '../../../@shared/mediaCarousel';
import { TMediaCarouselSlide } from '../../../@shared/mediaCarousel/types/mediaCarousel.types';

const Banner = (props: TBannerProps): JSX.Element => {
  const {
    component: model,
    mediaCarouselClassName,
    mediaHeightClassName,
    mobileRenditionKey,
    desktopRenditionKey,
    shouldShowOnlyFirstItem,
  } = props;

  const mediaCarouselSlides: TMediaCarouselSlide[] = [];

  model.assets?.forEach((asset) => {
    mediaCarouselSlides.push({
      isVideo: (asset.role === 'video' || asset.role === 'extvideo') && !!asset.full,
      videoUrl: { value: { href: asset.full } },
      productImageProps: {
        mobileRendition: asset?.[mobileRenditionKey || 'rendition_mobile_size500'],
        desktopRendition: asset?.[desktopRenditionKey || 'rendition_desktop_size1200'],
        ...(asset.role === 'extvideo' && { mobileRendition: { url: getThumbnailProps(asset.full)?.thumbnailImgSrc || '' } }),
        alt: asset.alt,
      },
    });
  });

  return (
    <MediaCarousel
      slides={shouldShowOnlyFirstItem && mediaCarouselSlides.length >= 1 ? [mediaCarouselSlides[0]] : mediaCarouselSlides}
      mediaHeightClassName={mediaHeightClassName}
      extraClassName={mediaCarouselClassName}
      label={props?.component?.eyebrow}
      useAnalytics
    />
  );
};

export default Banner;
